export const GET_QUESTION_STORIES = '[QUESTION STORIES] GET_QUESTION_STORIES'
export const GET_QUESTION_STORY = '[QUESTION STORIES] GET_QUESTION_STORY'
export const GET_GRADES = '[QUESTION STORIES] GET_GRADES'
export const GET_SUBJECT = '[QUESTION STORIES] GET_SUBJECT'
export const GET_TOPIC = '[QUESTION STORIES] GET_TOPIC'
export const GET_SUBTOPIC = '[QUESTION STORIES] GET_SUBTOPIC'
export const GET_LANGUAGES = '[QUESTION STORIES] GET_LANGUAGES'
export const COURSE_SET_STATE = 'SET STATE COURSE'